import React from "react";
import { FiArrowUpRight, FiGithub, FiLinkedin, FiMail, FiPhone } from "react-icons/fi";
import { SiKofi } from "react-icons/si";
import { useLanguage } from "../../i18n/LanguageContext";
import { profile } from "../../data/profile";
import { Reveal } from "../common/Reveal";
import { Icon } from "../common/Icon";
import "./Contact.css";

export function Contact() {
  const { t } = useLanguage();

  return (
    <section id="contact" className="section contact">
      <div className="contact__bg" aria-hidden="true">
        <span className="contact__bg-text">Let&rsquo;s talk</span>
        <div className="contact__glow" />
      </div>

      <div className="container section-inner contact__inner">
        <Reveal direction="up">
          <span className="eyebrow">{t.contact.eyebrow}</span>
          <h2 className="contact__heading">{t.contact.heading}</h2>
          <p className="section-sub contact__sub">{t.contact.subheading}</p>
        </Reveal>

        <Reveal direction="up" delay={0.15}>
          <div className="contact__actions">
            <a href={`mailto:${profile.email}`} className="btn btn-primary" data-cursor="hover">
              <Icon icon={FiMail} /> {t.contact.cta}
            </a>
            <span className="contact__availability">
              <span className="contact__availability-dot" />
              {t.contact.availability}
            </span>
          </div>
        </Reveal>

        <Reveal direction="up" delay={0.25}>
          <div className="contact__links">
            <a href={`mailto:${profile.email}`} className="contact__link" data-cursor="hover">
              <Icon icon={FiMail} />
              <span className="mono">{profile.email}</span>
              <Icon icon={FiArrowUpRight} className="contact__link-arrow" />
            </a>
            <a href={profile.phoneHref} className="contact__link" data-cursor="hover">
              <Icon icon={FiPhone} />
              <span className="mono">{profile.phone}</span>
              <Icon icon={FiArrowUpRight} className="contact__link-arrow" />
            </a>
            <a
              href={profile.github}
              target="_blank"
              rel="noopener noreferrer"
              className="contact__link"
              data-cursor="hover"
            >
              <Icon icon={FiGithub} />
              <span className="mono">{profile.githubHandle}</span>
              <Icon icon={FiArrowUpRight} className="contact__link-arrow" />
            </a>
            <a
              href={profile.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="contact__link"
              data-cursor="hover"
            >
              <Icon icon={FiLinkedin} />
              <span className="mono">{profile.linkedinHandle}</span>
              <Icon icon={FiArrowUpRight} className="contact__link-arrow" />
            </a>
            <a
              href={profile.kofi}
              target="_blank"
              rel="noopener noreferrer"
              className="contact__link"
              data-cursor="hover"
            >
              <Icon icon={SiKofi} />
              <span className="mono">{profile.kofiHandle}</span>
              <Icon icon={FiArrowUpRight} className="contact__link-arrow" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
